import { useEffect, useRef, useState } from "react";

type ScrollDirection = "up" | "down";

const SCROLL_THRESHOLD = 10;

export function useScrollDirection(): ScrollDirection {
  const [direction, setDirection] = useState<ScrollDirection>("up");
  const lastScrollY = useRef(0);

  useEffect(() => {
    function handleScroll() {
      const currentY = window.scrollY;
      const delta = currentY - lastScrollY.current;

      if (Math.abs(delta) >= SCROLL_THRESHOLD) {
        setDirection(delta > 0 ? "down" : "up");
        lastScrollY.current = currentY;
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return direction;
}
